module.exports = __webpack_public_path__ + "media/images/icon-mask-apple-7d241d0470b4381e35fca9ad6e381797.png";